<template>
  <div class="line-chart-container">
    <div class="legend-container">
      <div class="legend-item" v-for="item in seriesData" :key="item.name">
        <div class="legend-item-color" :style="{ backgroundColor: item.color }"></div>
        <div class="legend-item-name">{{ item.name }}</div>
      </div>
    </div>
    <div :id="chartDomId" class="chart-dom" :style="{ width: '100%', height: lineHeight + 'px' }"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'ScreenLineTimeChart',
  props: {
    seriesData: { type: Array, default: () => [] },
    lineHeight: { type: Number, default: 200 }
  },
  data() {
    return {
      chartDomId: 'echarts-line-time-' + Math.random().toString(36).slice(2, 9),
      chartInstance: null,
      resizeObserver: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect()
    if (this.chartInstance) this.chartInstance.dispose()
  },
  methods: {
    initChart() {
      this.$nextTick(() => {
        const el = document.getElementById(this.chartDomId)
        if (!el) return
        requestAnimationFrame(() => {
          if (!this.chartInstance) this.chartInstance = echarts.init(el)
          const seriesData = this.seriesData.map(item => ({
            name: item.name,
            type: 'line',
            smooth: true,
            showSymbol: false,
            data: item.data,
            lineStyle: { color: item.color }
          }))
          let axisData = []
          if (this.seriesData.length > 0) {
            axisData = this.seriesData[0].data.map(item => item[0])
          }
          this.chartInstance.setOption({
            grid: { left: 20, right: 35, top: 0, bottom: 25 },
            tooltip: { trigger: "axis" },
            xAxis: {
              type: 'category',
              minInterval: 1,
              boundaryGap: false,
              axisLine: { show: true, lineStyle: { color: '#5A5A89' } },
              axisTick: { show: true, lineStyle: { color: '#5A5A89' } },
              axisLabel: { fontSize: 12, fontWeight: 'bold', color: '#9292C1'},
              data: axisData
            },
            yAxis: { type: 'value', show: false },
            series: seriesData
          })
          this.chartInstance.resize()
          this.resizeObserver = new ResizeObserver(() => this.chartInstance && this.chartInstance.resize())
          this.resizeObserver.observe(el)
          setTimeout(() => this.chartInstance && this.chartInstance.resize(), 80)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.line-chart-container {
  width: 100%;
  padding-top: 20px;
  box-sizing: border-box;

  .legend-container {
    display: flex;
    padding-top: 30px;
    padding-bottom: 20px;
    justify-content: flex-end;
    align-items: center;
    gap: 19px;

    .legend-item {
      display: inline-flex;
      align-items: center;
      gap: 6px;

      .legend-item-color {
        width: 11px;
        height: 11px;
        border-radius: 50%;
      }

      .legend-item-name {
        font-size: 12px;
        color: #9292C1;
      }
    }
  }
}

.chart-dom {
  width: 100%;
  padding: 0;
  box-sizing: border-box;
}
</style>
